export const styleSheet = () => ({
    chartSpacer: {
        height: 4
    }
});
